<template>
  <div class="button btn-group">
    <button class="button-font btn btn-outline-primary" @click="sendFont()">
      {{ propsLabel }}
    </button>
    <button
      class="button-help btn btn-outline-primary" @click="showFonts()">
      <i class="fas fa-question-circle"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LayoutButtonFont',
  props: {
    propsLabel: String,
    propsFont: String,
    propsCharacter: String
  },
  methods: {
    showFonts () {
      this.$emit('showFonts', {
        dados: {
          font: this.propsFont,
          label: this.propsLabel,
          character: this.propsCharacter
        }
      })
    },
    sendFont () {
      this.$emit('sendFont', {
        dados: {
          font: this.propsFont,
          label: this.propsLabel
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  margin-right: 15px;
  margin-bottom: 15px;
  .button-font{
    width: 180px;
  }
}
</style>
